import { motion, useTransform, useScroll } from "framer-motion";
import React, { useRef } from "react";
import { HiArrowRight } from "react-icons/hi2";
import { BsArrow90DegRight } from "react-icons/bs";

const HorizontalScrollCarousel = () => {
    const targetRef = useRef(null);
    const { scrollYProgress } = useScroll({
        target: targetRef,
    });

    const x = useTransform(scrollYProgress, [0, 1], ["1.5%", "-91%"]);

    return (
        <section ref={targetRef} className="relative h-[300vh]">
            <div className="sticky top-0 flex h-screen items-center overflow-hidden">
                <motion.div style={{ x }} className="flex gap-4">
                    {cards.map((card) => {
                        return <Card card={card} key={card.id} />;
                    })}
                </motion.div>
            </div>
        </section>
    );
};

const Card = ({ card }) => {
    return (
        <div
            key={card.id}
            className="group relative h-screen overflow-hidden flex items-center"
        >
            <div className="px-4 py-10 sm:px-6 lg:px-8 lg:py-14 mx-auto flex">
                <div className="opacity-80 w-[60rem] bg-[url('https://dummyimage.com/900x600')] bg-center bg-cover bg-no-repeat relative rounded-xl min-h-[75vh]">
                    <div className="absolute bottom-0 start-0 end-0 max-w-xs text-center mx-auto p-6 md:start-auto md:text-start md:mx-0">
                        <motion.div
                            className="backdrop-blur-sm bg-white/70 px-5 py-4 inline-block rounded-lg md:p-7"
                            variants={{
                                hidden: { opacity: 0, x: -50 },
                                visible: { opacity: 1, x: 0 }
                            }}
                            initial="hidden"
                            whileInView="visible"
                            transition={{duration: 0.6, delay: 0.4}}
                            viewport={{once: false}}
                        >
                            <div className="hidden md:block">
                                <h3 className="text-lg font-bold text-blue-600 sm:text-2xl">{ card.situation }</h3>
                                <p className="mt-2 text-gray-800">{ card.description }</p>
                            </div>
                            <div className="md:mt-16">
                                <div className="flex items-center gap-2 text-sm font-medium text-gray-800 hover:text-gray-500" href="#">
                                    <svg className="flex-shrink-0 size-4" xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><polygon points="5 3 19 12 5 21 5 3"/></svg>
                                    { card.ref }
                                </div>
                            </div>
                        </motion.div>
                    </div>
                </div>
                { card.id!==7 ?
                    <motion.div
                        className="text-6xl my-auto ml-24 mr-8"
                        variants={{
                            hidden: { opacity: 0, x: -50 },
                            visible: { opacity: 1, x: 0 }
                        }}
                        initial="hidden"
                        whileInView="visible"
                        transition={{duration: 0.6, delay: 0.8}}
                        viewport={{once: false}}
                    >
                        <HiArrowRight />
                    </motion.div> :
                    <motion.div
                        className="my-auto text-6xl ml-24"
                        variants={{
                            hidden: { opacity: 0, y: -50 },
                            visible: { opacity: 1, y: 0 }
                        }}
                        initial="hidden"
                        whileInView="visible"
                        transition={{duration: 0.6, delay: 0.8}}
                        viewport={{once: false}}
                    >
                        <BsArrow90DegRight className="rotate-90" />
                    </motion.div> }
            </div>
        </div>
    );
};

const cards = [
    {
        situation: "Situation No.1",
        description: "Description for situation No.1 Description for situation No.1 Description for situation No.1",
        ref: "Reference No.1",
        id: 1
    },
    {
        situation: "Situation No.2",
        description: "Description for situation No.2 Description for situation No.2 Description for situation No.2",
        ref: "Reference No.2",
        id: 2
    },
    {
        situation: "Situation No.3",
        description: "Description for situation No.3 Description for situation No.3 Description for situation No.3",
        ref: "Reference No.3",
        id: 3
    },
    {
        situation: "Situation No.4",
        description: "Description for situation No.4 Description for situation No.4 Description for situation No.4",
        ref: "Reference No.4",
        id: 4
    },
    {
        situation: "Situation No.5",
        description: "Description for situation No.5 Description for situation No.5 Description for situation No.5",
        ref: "Reference No.5",
        id: 5
    },
    {
        situation: "Situation No.6",
        description: "Description for situation No.6 Description for situation No.6 Description for situation No.6",
        ref: "Reference No.6",
        id: 6
    },
    {
        situation: "Situation No.7",
        description: "Description for situation No.7 Description for situation No.7 Description for situation No.7",
        ref: "Reference No.7",
        id: 7
    }
];

export default function HorizontalScrollGallery(){
    return(
        <HorizontalScrollCarousel />
    )
}